// Converted to .js.liquid for locale injection
document.addEventListener("DOMContentLoaded", function () {
  console.log("-Se qualcosa non funziona, usa un grande martello-");

  // Filter hint tooltip — show once per user via localStorage
  (function () {
    var HINT_KEY = 'filter_hint_seen';
    var tooltip = document.getElementById('filter-hint-tooltip');
    if (!tooltip) return;
    if (!localStorage.getItem(HINT_KEY)) {
      // Only show if the filter toolbar is visible (collection/search pages)
      var toolbar = document.getElementById('mobile-facet-toolbar');
      if (toolbar) {
        tooltip.classList.add('is-visible');
        var closeBtn = tooltip.querySelector('.filter-hint-tooltip__close');
        function dismissHint() {
          tooltip.classList.remove('is-visible');
          localStorage.setItem(HINT_KEY, '1');
        }
        if (closeBtn) closeBtn.addEventListener('click', dismissHint);
        // Also dismiss when the user opens the filter
        var filterBtn = toolbar.querySelector('.mobile-toolbar__item--filters');
        if (filterBtn) filterBtn.addEventListener('click', dismissHint, { once: true });
      }
    }
  })();
  // Locale: prefer HTML lang, fallback to Liquid, then default
  const lang = (document.documentElement.lang || '{{ request.locale.iso_code | split: '-' | first }}' || 'it').slice(0,2);

  // customizzazione megamenu (DISABILITATA per reset base menu desktop)
  if (false) {
    function updateMegaMenuTitles() {
      const elements = document.querySelectorAll("a.link--faded");
      elements.forEach((element) => {
        const text = element.textContent;
        if (text.includes("__big")) {
          const newText = text.replace("__big", "");
          element.textContent = newText;
          element.classList.add("heading--small");
        }
      });
    }
    updateMegaMenuTitles();

    function wrapAll(elements, wrapper) {
      if (elements && elements.length > 0) {
        elements[0].parentNode.insertBefore(wrapper, elements[0]);
        Array.from(elements).forEach((element) => {
          wrapper.appendChild(element);
        });
      }
    }

    //___Marchi
    const menuMarchiCol1Elements = document.querySelectorAll(
      "#desktop-menu-1 .mega-menu__column:nth-child(n+6):nth-child(-n+12)"
    );
    const menuMarchiCol2Elements = document.querySelectorAll(
      "#desktop-menu-1 .mega-menu__column:nth-child(n+13)"
    );

    const wrapperMarchi1 = document.createElement("div");
    wrapperMarchi1.className = "menu_ctrl marchi1";
    wrapAll(menuMarchiCol1Elements, wrapperMarchi1);

    const wrapperMarchi2 = document.createElement("div");
    wrapperMarchi2.className = "menu_ctrl marchi2";
    wrapAll(menuMarchiCol2Elements, wrapperMarchi2);

    //___Kit
    const menuKitElements = document.querySelectorAll(
      "#desktop-menu-2 .mega-menu__column:nth-child(n+2):nth-child(-n+8)"
    );

    const wrapperElements1 = document.createElement("div");
    wrapperElements1.className = "menu_ctrl kit";
    wrapAll(menuKitElements, wrapperElements1);

    //___Attrezzature
    const menuAttrezzatureCol1Elements = document.querySelectorAll(
      "#desktop-menu-7 .mega-menu__column:nth-child(n+6):nth-child(-n+10)"
    );
    const menuAttrezzatureCol2Elements = document.querySelectorAll(
      "#desktop-menu-7 .mega-menu__column:nth-child(n+11)"
    );

    const wrapperAttrezzature1 = document.createElement("div");
    wrapperAttrezzature1.className = "menu_ctrl attrezzature1";
    wrapAll(menuAttrezzatureCol1Elements, wrapperAttrezzature1);

    const wrapperAttrezzature2 = document.createElement("div");
    wrapperAttrezzature2.className = "menu_ctrl attrezzature2";
    wrapAll(menuAttrezzatureCol2Elements, wrapperAttrezzature2);

    //___Strumenti
    const menuStrumentiCol1Elements = document.querySelectorAll(
      "#desktop-menu-6 .mega-menu__column:nth-child(n+3):nth-child(-n+7)"
    );
    const menuStrumentiCol2Elements = document.querySelectorAll(
      "#desktop-menu-6 .mega-menu__column:nth-child(n+8)"
    );

    const wrapperStrumenti1 = document.createElement("div");
    wrapperStrumenti1.className = "menu_ctrl strumenti1";
    wrapAll(menuStrumentiCol1Elements, wrapperStrumenti1);

    const wrapperStrumenti2 = document.createElement("div");
    wrapperStrumenti2.className = "menu_ctrl strumenti1";
    wrapAll(menuStrumentiCol2Elements, wrapperStrumenti2);

    //custom menu bar
    const hookMenu1 = document.querySelector(
      'li.header__linklist-item[data-item-title="Kit"]'
    );
    const hookMenu2 = document.querySelector(
      'li.header__linklist-item[data-item-title="Guide"]'
    );

    const newDivAfter = document.createElement("div");
    newDivAfter.style.color = "#4bdd0e";
    newDivAfter.innerHTML = "///";

    hookMenu1.parentNode.insertBefore(newDivAfter, hookMenu1.nextSibling);

    const newDivBefore = document.createElement("div");
    newDivBefore.style.color = "#4bdd0e";
    newDivBefore.innerHTML = "///";

    hookMenu2.parentNode.insertBefore(newDivBefore, hookMenu2);
  }

  // separatori grafici menu desktop (attivi)
  const desktopMenuList = document.querySelector(
    ".header__bottom-navigation .header__linklist"
  );

  if (desktopMenuList) {
    const topLevelItems = Array.from(
      desktopMenuList.querySelectorAll(":scope > li.header__linklist-item")
    );

    const createMenuSeparator = () => {
      const separator = document.createElement("li");
      separator.className = "header__linklist-separator";
      separator.setAttribute("aria-hidden", "true");
      separator.style.color = "#4bdd0e";
      separator.textContent = "///";
      return separator;
    };

    if (topLevelItems.length >= 3) {
      const secondItem = topLevelItems[1];
      const afterSecondSibling = secondItem ? secondItem.nextElementSibling : null;
      if (
        secondItem &&
        (!afterSecondSibling ||
          !afterSecondSibling.classList.contains("header__linklist-separator"))
      ) {
        secondItem.insertAdjacentElement("afterend", createMenuSeparator());
      }
    }

    if (topLevelItems.length >= 5) {
      const beforeLastTwoItem = topLevelItems[topLevelItems.length - 2];
      const beforePrevSibling = beforeLastTwoItem
        ? beforeLastTwoItem.previousElementSibling
        : null;
      if (
        beforeLastTwoItem &&
        (!beforePrevSibling ||
          !beforePrevSibling.classList.contains("header__linklist-separator"))
      ) {
        beforeLastTwoItem.insertAdjacentElement("beforebegin", createMenuSeparator());
      }
    }
  }


  if (document.querySelector("#product h1.product-meta__title")) {
    const getProductTitle = document.querySelector(
      "#product h1.product-meta__title"
    ).textContent;

    if (getProductTitle === "Cartec Ceramic Guard Coating SiCarbon+") {
      document.body.classList.add("centro_autorizzato");

      const addToCartButton = document.querySelector(
        ".centro_autorizzato button#AddToCart .loader-button__text"
      );
      if (addToCartButton) {
        addToCartButton.textContent = "Trova il centro autorizzato più vicino";

        addToCartButton.addEventListener("click", function () {
          window.location.href =
            "https://new-focal-test.myshopify.com/blogs/news";
          //console.log("click");
        });
      }
    }
  }

  //customizzazione up-bar
  const upBar = document.querySelector(
    ".announcement-bar__message.text--xsmall p"
  );
  //upBar.html('<img style="margin:0 5px; height: 18px;" src="https://cdn.shopify.com/s/files/1/0660/5252/2209/files/lettering_carismatix_c31cb1f6-7169-4adb-8c98-6857b5147578_400x.png?v=1663582740" alt="Carismatix"> È IL NUOVO MARCHIO DI <img style="height: 36px; margin: -8px 5px -8px 5px;" src="https://cdn.shopify.com/s/files/1/0660/5252/2209/files/cartec_quadrato.jpg?v=1665413033" alt="Cartec"> ITALIA → <button class="link" data-action="open-content">Cosa cambia?</button>');

  //pagine prodotto NO VENDITA ___

    //nomi prodotti NoVendita
    const QuarzProfessional = "CARPRO C.QUARTZ Professional";
    const QuarzFinest = "CARPRO C.QUARTZ Finest Reserve Kit";
    const DQuartz = "CARPRO D.Quartz";
    const QuarzFinest2025 = "CARPRO C.QUARTZ Finest Reserve 2025";


    const box_grigio = document.querySelector(".box_decor_gray");
    const barra_aggiungi = document.querySelector(".product-sticky-form");

    //rimuovo barra da prodotti no vendita
    var productTitle = document.querySelector("h1.product-meta__title");
    if (productTitle) {
      productTitle = productTitle.textContent;
    }

    //miniatura prodotto
    setTimeout(function () {
      // Funzione helper per rimuovere l'elemento successivo
      function removeNextIfTitleContains(query, text) {
        document.querySelectorAll(query).forEach(function (item) {
          if (item.textContent.includes(text)) {
            if (item.nextElementSibling) {
              item.nextElementSibling.remove();
            }
          }
        });
      }

      // Applica la funzione ai vari titoli
      removeNextIfTitleContains(
        "product-item.product-item .product-item-meta__title",
        "CeramicGuard"
      );
      removeNextIfTitleContains(
        "product-item.product-item .product-item-meta__title",
        "QuarzProfessional"
      );
      removeNextIfTitleContains(
        "product-item.product-item .product-item-meta__title",
        "QuarzFinest"
      );
      removeNextIfTitleContains(
        "product-item.product-item .product-item-meta__title",
        "DQuartz"
      );
      removeNextIfTitleContains(
        "product-item.product-item .product-item-meta__title",
        "QuarzFinest2025"
      );
    }, 1000);

    const noVenditaTitles = [
      "CeramicGuard",
      "QuarzProfessional",
      "QuarzFinest",
      "DQuartz",
      "QuarzFinest2025",
    ];
    if (noVenditaTitles.includes(productTitle)) {
      if (box_grigio) box_grigio.remove();
      if (barra_aggiungi) barra_aggiungi.remove();
    }
  //prodotti no vendita FINE ___


  // Separo righe - multi-line-text - SCHEDA TECNICA
  setTimeout(function () {
    const getTab = document.querySelector(
      "#block-template--16611716104421__product-content-58e82b46-6d21-489f-95ed-5cffdacd23a4-content p"
    );
    if (getTab) {
      const newTextTab = getTab.textContent.replace(/, /g, "\n");
      getTab.innerHTML = newTextTab;
    }
  }, 1000);

  //clicco la sezione
  setTimeout(function () {
    //("add");
    // Seleziona gli elementi e aggiunge la classe
    const elements = document.querySelectorAll(".eapps-google-maps-small");
    elements.forEach((element) => {
      element.classList.add("eapps-google-maps-bar-opened");
    });
  }, 5000);

  //mini cart visibility (deduplicated)
  document
    .querySelectorAll('a[aria-controls="mini-cart"]')
    .forEach(function (element) {
      element.addEventListener("click", function () {
        const checkoutButton = document.querySelector(
          "#mini-cart .checkout-button"
        );
        if (checkoutButton) {
          checkoutButton.addEventListener("mouseenter", function () {
            var rawa = document.querySelector("#rawa-button");
            if (rawa) rawa.classList.add("none");
          });

          checkoutButton.addEventListener("mouseleave", function () {
            var rawa = document.querySelector("#rawa-button");
            if (rawa) rawa.classList.remove("none");
          });
        }
      });
    });

  //cart bundle customization
  const bundleElements = document.querySelectorAll(
    "#cart .th_bundle_discount_text"
  );
  bundleElements.forEach(function (element) {
    if (element.textContent.indexOf("Bundle") !== -1) {
      let ancestor = element;
      for (let i = 0; i < 7; i++) {
        ancestor = ancestor.parentNode;
      }
      const quantitySelector = ancestor.querySelector(".quantity-selector");
      if (quantitySelector) {
        quantitySelector.remove();
      }
    }
  });

  //autoscroll mobile rivenditori
  window.addEventListener("load", function () {
    if (
      window.location.href === "https://cirismatix.com/pages/rivenditori" &&
      window.innerWidth < 767
    ) {
      setTimeout(function () {
        window.scroll({
          top: window.scrollY + 160,
          left: 0,
          behavior: "smooth",
        });
      }, 2000);
    }
  });

  //class per landingp prodotti Marco
  const heroBoxLanding = document.querySelector("#cartec_refinish_hero_box");
  if (heroBoxLanding) {
    document.body.classList.add("landing_product_page");
  }

  //bug shinemate
  const shineMateVendor = document.querySelector(".product-meta__vendor a"); //Shinemate
  const optionShinemate = document.querySelectorAll(
    ".product .product-form .product-form__variants .select-wrapper button"
  );
  //tolgo righe extra pagina account utente > programma fedeltà
  setTimeout(() => {
    const puntiNegativi = document.querySelectorAll(".bon-text-danger");
    if (puntiNegativi) {
      puntiNegativi.forEach(function (elemento) {
        elemento.parentNode.remove();
      });
    }
  }, 2000);

  //bundle - volume | acquisto multiplo, utente deve poter scegliere 1 variante per tutto il pacchetto

  const selects = document.querySelectorAll(
    "select.th_pb_wf.th_pb_qty_grid_select_cls.wc_single_option_selector"
  );

  // Verifica che gli elementi siano stati selezionati correttamente
  //console.log("Select elements found:", selects.length);

  // Aggiungi un event listener al primo elemento <select>
  if (selects.length > 0) {
    selects[0].addEventListener("change", function () {
      //console.log("Change event detected");
      const selectedValue = this.value;
      selects.forEach((select, index) => {
        if (index !== 0) {
          select.value = selectedValue;
        }
      });
    });

    selects[0].addEventListener("input", function () {
      //console.log("Input event detected");
      const selectedValue = this.value;
      selects.forEach((select, index) => {
        if (index !== 0) {
          select.value = selectedValue;
        }
      });
    });
  } else {
    //console.log("No select elements found");
  }

  /* Se bundle KIT allora whishlist in fixed
  setTimeout(function () {
    var titoloBundleElement = document.querySelector(
      ".thpb_combo_wflex .thpb_combo_title .thpb_combo_wflex"
    );
    var targetSection = document.querySelector(".thpb_combo_cta_btn_section");

    if (
      titoloBundleElement &&
      titoloBundleElement.textContent.includes("Questo KIT contiene")
    ) {
      var buttonWishlist = document.querySelector(
        ".swym-button-bar.swym-wishlist-button-bar.swym-inject"
      );
      if (buttonWishlist) {
        buttonWishlist.remove();
        targetSection.appendChild(buttonWishlist);
        buttonWishlist.classList.add("attivo_bundle");
      } else {
        //console.log("no_wbtn");
      }
    }
  }, 2500);
  */
 
  // aggiornamento numerino carrello quando metto in carrello prodotto da wishlist
  setTimeout(function () {
    const notificationBanner = document.querySelector(
      ".swym-wishlist-notifications-container"
    );
    if (notificationBanner) {
      //console.log('ifpassed');
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          let notificationBannerNoProd = document.querySelector(
            ".swym-wishlist-notifications-container .swym-details"
          );

          if (
            mutation.addedNodes.length > 0 &&
            (!notificationBannerNoProd ||
              !notificationBannerNoProd.textContent.includes(
                "Non puoi aggiungere"
              ))
          ) {
            //console.log('mutationpassed');
            let numerinoCarrello = document.querySelector(
              "cart-count.header__cart-count"
            );
            let newNumber = parseInt(numerinoCarrello.textContent) + 1;
            numerinoCarrello.textContent = newNumber;
          }
        });
      });
      observer.observe(notificationBanner, { childList: true });
    }
  }, 2500);

  /*inverto ordine lista scheda tecnica*/
  const tabSchedaTecnica = [
    ...document.querySelectorAll('.collapsible-toggle[is="toggle-button"]'),
  ].find((el) => el.textContent.includes("SCHEDA TECNICA"));
  if (tabSchedaTecnica) {
    //console.log(tabSchedaTecnica);
    const schedaContainer = tabSchedaTecnica.nextElementSibling.children[0];
    if (schedaContainer) {
      //console.log(schedaContainer);
      setTimeout(function () {
        schedaContainer.style.display = "flex";
        schedaContainer.style.flexDirection = "column-reverse";
      }, 500);
    }
  }

  // --- --- --- funzione form Partecipanti - Training Days - OFF (DEFINITA GLOBALMENTE)

  //primo form
  function campoCondizionaleTrainigDays() {
    const aziendaSelect = document.querySelector('.azienda_select');
    const aziendaInput = document.querySelector('.azienda_input');
  
    aziendaSelect.addEventListener('change', function() {
      if (this.value === 'Azienda') {
        aziendaInput.classList.add('attivo');
      } else {
        aziendaInput.classList.remove('attivo');
      }
    });
  }
  //NO varianti
  function gestisciFormDinamicoPartecipanti() {
    const minusButton = document.querySelector(
      "quantity-selector.quantity-selector .quantity-selector__button:first-child"
    );
    const plusButton = document.querySelector(
      "quantity-selector.quantity-selector .quantity-selector__button:last-child"
    );
    const partecipantiContainer = document.getElementById(
      "partecipanti-container"
    );
    const quantityInput = document.querySelector(
      ".product-form__quantity .quantity-selector__input"
    );

    // Inizializziamo numberQuantity a 1
    let numberQuantity = 1;

    function generaFormPartecipante(numero) {
      const itemPartecipante = document.createElement("div");
      itemPartecipante.classList.add("item_partecipante");

      itemPartecipante.innerHTML = `
              <p class="titolo">Partecipante ${numero}</p>
              <p class="titolo_sub" style="font-size:75%;">Obbligatorio compilare i dati del partecipante ${numero}. (*Campi obbligatori)</p>
              <input
                  required
                  type="text"
                  name="properties[Nome ${numero}]"
                  placeholder="Nome e Cognome (*)"
                  minlength="3"
                  maxlength="50"
                  title="Inserisci il tuo nome e cognome (minimo 3 caratteri, massimo 50)')"
                  oninvalid="this.setCustomValidity('Inserisci il tuo nome e cognome (minimo 3 caratteri, massimo 50)')"
                  oninput="this.setCustomValidity('')"
              />
              <input
                  required
                  type="email"
                  name="properties[Email ${numero}]"
                  placeholder="Email (*)"
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  title="Inserisci un indirizzo email valido (es: nome@esempio.com)"
                  oninvalid="this.setCustomValidity('Inserisci il tuo nome e cognome (minimo 3 caratteri, massimo 50)')"
                  oninput="this.setCustomValidity('')"
              />
              `;

      return itemPartecipante;
    }

    function aggiornaFormPartecipanti() {
      //console.log('aggiorna forms con quantity:', numberQuantity);
      partecipantiContainer.innerHTML = ""; // Pulisce il container

      // Genera partecipanti dal 2 in poi SOLO se numberQuantity è 2 o più
      if (numberQuantity >= 2) {
        for (let i = 2; i <= numberQuantity; i++) {
          const formPartecipante = generaFormPartecipante(i);
          partecipantiContainer.appendChild(formPartecipante);
        }
      }
    }

    // Ottieni il valore massimo dall'attributo 'max' (se presente)
    const inputMax = quantityInput.hasAttribute("max")
      ? parseInt(quantityInput.getAttribute("max"), 10)
      : Infinity;

    // Listener per il pulsante "+"
    plusButton.addEventListener("click", function () {
      if (numberQuantity < inputMax) {
        // Controlla se numberQuantity è inferiore a inputMax
        numberQuantity++; // Incrementa numberQuantity
        aggiornaFormPartecipanti(); // Aggiorna i form
      }
    });

    // Listener per il pulsante "-"
    minusButton.addEventListener("click", function () {
      numberQuantity = Math.max(1, numberQuantity - 1); // Decrementa numberQuantity, ma non sotto 1
      aggiornaFormPartecipanti(); // Aggiorna i form
    });

    // Inizializza il form con numberQuantity = 1
    aggiornaFormPartecipanti();
  }
  //CON varianti
  function gestisciFormDinamicoPartecipanti_varianti() {
    let selectPersone = document.querySelector(
      "product-variants.product-form__variants .select__selected-value"
    );
    const partecipantiContainer = document.getElementById(
      "partecipanti-container"
    );

    function generaFormPartecipante(numero) {
      const itemPartecipante = document.createElement("div");
      itemPartecipante.classList.add("item_partecipante");

      itemPartecipante.innerHTML = `
              <p class="titolo">Partecipante ${numero}</p>
              <p class="titolo_sub" style="font-size:75%;">Obbligatorio compilare i dati del partecipante ${numero}. (*Campi obbligatori)</p>
              <input
                  required
                  type="text"
                  name="properties[Nome ${numero}]"
                  placeholder="Nome e Cognome (*)"
                  minlength="3"
                  maxlength="50"
                  title="Inserisci il tuo nome e cognome (minimo 3 caratteri, massimo 50)')"
                  oninvalid="this.setCustomValidity('Inserisci il tuo nome e cognome (minimo 3 caratteri, massimo 50)')"
                  oninput="this.setCustomValidity('')"
              />
              <input
                  required
                  type="email"
                  name="properties[Email ${numero}]"
                  placeholder="Email (*)"
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  title="Inserisci un indirizzo email valido (es: nome@esempio.com)"
                  oninvalid="this.setCustomValidity('Inserisci il tuo nome e cognome (minimo 3 caratteri, massimo 50)')"
                  oninput="this.setCustomValidity('')"
              />
          `;

      return itemPartecipante;
    }
    function aggiornaFormPartecipanti(numero_persone) {
      //console.log('aggiorna forms con quantity:', numberQuantity);
      partecipantiContainer.innerHTML = ""; // Pulisci container

      // Genera partecipanti in base al numeroPersone
      if (numero_persone >= 2) {
        for (let i = 2; i <= numero_persone; i++) {
          const formPartecipante = generaFormPartecipante(i);
          partecipantiContainer.appendChild(formPartecipante);
        }
      }
    }

    //prendo il numero dalla stringa "selectPersone" al cambio di option
    if (!selectPersone) {
      console.error("Elemento selectPersone non trovato nel DOM");
    } else {
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData"
          ) {
            // Usa il testo aggiornato dall'elemento
            let selectPersoneStringa = selectPersone.textContent;
            let match = selectPersoneStringa.match(/\d/);
            if (match) {
              const numeroPersone = parseInt(match[0], 10);
              console.log("Numero persone:", numeroPersone);
              aggiornaFormPartecipanti(numeroPersone);
            }
          }
        });
      });
      observer.observe(selectPersone, {
        characterData: true,
        childList: true,
        subtree: true,
      });
    }
  }

  //inizializza

    //document.body.classList.contains("is_training_days");
    //document.body.classList.contains("is_bundle_product");
  if ( document.body.classList.contains("is_training_days") && document.body.classList.contains("has_variants") ) {
    gestisciFormDinamicoPartecipanti_varianti();
    campoCondizionaleTrainigDays();
    //console.log("training days - yes variant");
  } else if ( document.body.classList.contains("is_training_days") ) {
    gestisciFormDinamicoPartecipanti();
    campoCondizionaleTrainigDays();
    //console.log("training days - no variant");
  }


  if (lang == "en") {
    //wishlist
    setTimeout(function () {
      var wishlistHeader = document.querySelector(
        ".swym-wishlist-detail-header"
      );
      setTimeout(function () {
        var listAggiungiButtons = document.querySelectorAll(
          "button.swym-add-to-cart-btn"
        );
        if (listAggiungiButtons) {
          listAggiungiButtons.forEach(function (el) {
            el.innerText = "ADD TO CART";
            el.addEventListener("click", function () {
              setTimeout(function () {
                listAggiungiButtons.forEach(function (el_inner) {
                  el_inner.innerText = "ADD TO CART";
                });
              }, 1000);
            });
          });
        }
      }, 1000);
      //console.log(wishlistHeader);
      if (wishlistHeader) {
        wishlistHeader.style.justifyContent = "space-between";
        wishlistHeader.style.flexDirection = "row-reverse";

        var newHtml =
          '<div><a href="https://cirismatix.com/en/account" class="fade-in" style="display:inline-block;margin-right:20px;">Return to Account</a><a href="https://cirismatix.com/en/" class="fade-in">Return to Home</a></div>';

        wishlistHeader.innerHTML = newHtml + wishlistHeader.innerHTML;
        wishlistHeader.querySelector("#swym-modal-wishlist-title").innerText =
          "My Wishlist";
      }
    }, 2000);
  } else {
    //wishlist
    setTimeout(function () {
      var wishlistHeader = document.querySelector(
        ".swym-wishlist-detail-header"
      );
      //console.log(wishlistHeader);
      if (wishlistHeader) {
        wishlistHeader.style.justifyContent = "space-between";
        wishlistHeader.style.flexDirection = "row-reverse";

        var newHtml =
          '<div><a href="https://cirismatix.com/account" class="fade-in" style="display:inline-block;margin-right:20px;">Torna al tuo Account</a><a href="https://cirismatix.com/" class="fade-in">Torna alla Home</a></div>';

        wishlistHeader.innerHTML = newHtml + wishlistHeader.innerHTML;
      }
    }, 2000);
  }

  // Rimosso blocco legacy per ridurre payload e dipendenze

  //Slick Homepage
  // Lazy-load jQuery + Slick only if needed and not already present
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function (e) { reject(e); };
      document.head.appendChild(s);
    });
  }

  function loadCSS(href) {
    if (document.querySelector('link[data-slick-css]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.setAttribute('data-slick-css', '1');
    document.head.appendChild(l);
  }

  function ensureJqueryAndSlickIfNeeded() {
    var needsSlick = document.querySelector('product-list#id_ESTERNI, product-list#id_INTERNI, product-list#id_STRUMENTI');
    if (!needsSlick) {
      return Promise.resolve(false);
    }

    var chain = Promise.resolve();
    if (!window.jQuery) {
      chain = chain.then(function(){ return loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js'); });
    }
    return chain.then(function(){
      // Load Slick assets if not present
      loadCSS('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css');
      if (window.jQuery && jQuery.fn && typeof jQuery.fn.slick === 'function') {
        return true;
      }
      return loadScript('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js').then(function(){ return true; });
    });
  }

  function initCarDetailingSlick() {
    const carDetailingTabs = $('product-list#id_ESTERNI, product-list#id_INTERNI, product-list#id_STRUMENTI');

    //  Controllo iniziale: esistono e siamo su desktop?
    if (!carDetailingTabs.length || window.innerWidth < 740) return;

      const slickOptions = {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrow: true,
        centerPadding: '10px',
        nextArrow: `<svg class="next_arrow" width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#0a1320"><path d="M9 6L15 12L9 18" stroke="#0a1320" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
        prevArrow: `<svg class="prev_arrow" width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#0a1320"><path d="M15 6L9 12L15 18" stroke="#0a1320" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`
      };

      function initSlickIfNeeded($el) {
        if (!$el.hasClass('slick-initialized')) {
          $el.slick(slickOptions);
        } else {
          $el.slick('setPosition');
        }
      }

      //  Inizializza solo la tab visibile al primo load
      carDetailingTabs.filter(':visible').each(function () {
        initSlickIfNeeded($(this));
      });

      //  Observer per le altre tab quando diventano visibili
      const observer = new MutationObserver(function () {
        carDetailingTabs.each(function () {
          const $el = $(this);
          if ($el.is(':visible')) {
            initSlickIfNeeded($el);
          }
        });
      });

      //  Attiva observer su tutte le tab
      carDetailingTabs.each(function () {
        observer.observe(this, { attributes: true, attributeFilter: ['hidden'] });
      });
  }

  // Conditionally ensure dependencies then run
  ensureJqueryAndSlickIfNeeded().then(function(ready){
    if (ready) {
      initCarDetailingSlick();
    }
  }).catch(function(err){
    console.error('Slick lazy-load failed', err);
  });

});
